import { useEffect } from 'react';
import { useSignalR } from 'contexts/signalerContext';
import { dispatch } from 'store';
import { notificationsActions, fetchNewMessagesCountAction } from 'store/reducers/notificationsReducer';
import useAuth from 'hooks/useAuth';

/**
 * Component that listens for NewMessageCountEvent from SignalR
 * and updates Redux store (only for authenticated users)
 */
export default function NotificationListener() {
  const connection = useSignalR();
  const { isAuthenticated } = useAuth();

  // Initialize on authentication
  useEffect(() => {
    if (!isAuthenticated) return;

    // Fetch initial count on authentication
    dispatch(fetchNewMessagesCountAction()).catch((error) => console.error('fetchNewMessagesCountAction failed:', error));
  }, [isAuthenticated]);

  // Listen to WebSocket events
  useEffect(() => {
    if (!connection || !isAuthenticated) return;

    // Set up listener for NewMessageCountEvent
    const handleNewMessageCount = (messageCount) => {
      dispatch(notificationsActions.updateNewMessagesCount(messageCount));
    };

    connection.on('NewMessageCountEvent', handleNewMessageCount);

    return () => {
      connection.off('NewMessageCountEvent', handleNewMessageCount);
    };
  }, [connection, isAuthenticated]);

  return null;
}
